import { useState, useEffect } from 'react';
import { storage as localStorage } from '../utils/storage';

const useKeywordManagement = () => {
  const [keywords, setKeywords] = useState<string[]>([]);
  const [newKeyword, setNewKeyword] = useState('');

  // Load keywords from local storage on mount
  useEffect(() => {
    const fetchKeywords = async () => {
      const storedKeywords = await localStorage.get('keywords');
      if (storedKeywords) {
        setKeywords(JSON.parse(storedKeywords));
      }
    };
    fetchKeywords();
  }, []);

  // Save keywords to local storage when they change
  useEffect(() => {
    const saveKeywords = async () => {
      await localStorage.set('keywords', JSON.stringify(keywords));
    };
    saveKeywords();
  }, [keywords]);

  // Function to add a new keyword
  const addKeyword = () => {
    if (newKeyword.trim() && !keywords.includes(newKeyword.trim().toLowerCase())) {
      setKeywords([...keywords, newKeyword.trim().toLowerCase()]);
      setNewKeyword('');
    }
  };

  // Function to remove a keyword
  const removeKeyword = (keywordToRemove: string) => {
    setKeywords(keywords.filter((keyword) => keyword !== keywordToRemove));
  };

  return {
    keywords,
    newKeyword,
    setNewKeyword,
    addKeyword,
    removeKeyword,
  };
};

export default useKeywordManagement;
